function seriesHighlight(chartInstance: SceneChart, seriesData: SceneChart.DataSeries) {
  chartInstance.data.datasets?.forEach(dataset => {
    let highlight = dataset.highlight
    if (!highlight) {
      return
    }

    let highlightColor = highlight.color
    let highlightCondition = highlight.condition

    seriesData.forEach((sdata, sIndex) => {
      sdata.forEach((data: SceneChart.Data, i: number) => {
        try {
          if (!new Function('return ' + highlightCondition)()) {
            return
          }
        } catch {
          return
        }

        let meta = chartInstance.getDatasetMeta(sIndex)
        // v4: use element options instead of removed _model
        const element = meta.data[i] as any
        if (element) {
          element.options = element.options || {}
          element.options.backgroundColor = highlightColor
        }
      })
    })
  })
}

export default {
  id: 'chart-series-highlight',
  beforeDraw: function (chartInstance: SceneChart) {
    if (!chartInstance.data.rawData) {
      return
    }

    let seriesData = chartInstance.data.rawData.seriesData
    seriesHighlight(chartInstance, seriesData)
  }
}
